/* A HORIZONTAL SCROLLBAR ON TOP of a wide table (Jay, System Project task 30/10, Roles & Permissions: "The horizontal
   scrollbar sits at the bottom of the table, so Jay has to scroll all the way down just to see the role columns on the
   right"). A thin bar above the scrolling box, as wide as the box's content, moving with it both ways; hidden when nothing
   is wider than the box. Give it the ref of the element that scrolls (overflow-x: auto). */
import React, { useEffect, useRef, useState } from 'react';

export default function TopScrollbar({ target, className = '' }) {
  const bar = useRef(null);
  const [w, setW] = useState(0);
  const [show, setShow] = useState(false);
  useEffect(() => {
    const el = target.current; const b = bar.current;
    if (!el || !b) return undefined;
    const measure = () => { setW(el.scrollWidth); setShow(el.scrollWidth > el.clientWidth + 1); };
    let lock = false;   // one side moving the other must not move it back
    const fromBox = () => { if (lock) { lock = false; return; } lock = true; b.scrollLeft = el.scrollLeft; };
    const fromBar = () => { if (lock) { lock = false; return; } lock = true; el.scrollLeft = b.scrollLeft; };
    measure();
    el.addEventListener('scroll', fromBox, { passive: true }); b.addEventListener('scroll', fromBar, { passive: true });
    const ro = new ResizeObserver(measure); ro.observe(el); if (el.firstElementChild) ro.observe(el.firstElementChild);
    return () => { el.removeEventListener('scroll', fromBox); b.removeEventListener('scroll', fromBar); ro.disconnect(); };
  }, [target]);
  return (
    <div ref={bar} className={`top-scrollbar ${className}`} style={{ overflowX: 'auto', overflowY: 'hidden', height: show ? 14 : 0 }} aria-hidden="true" data-top-scrollbar>
      <div style={{ width: w, height: 1 }} />
    </div>
  );
}
